import React from "react";
import Vehical from "./Vehicle";
import "../../styles/products.css";
import "../../styles/styles.css";

function products() {
  return (
    <div id="main-products" >
      <h2 id="our-product-heading">OUR PRODUCTS</h2>
      <div className="product-grid">
        <div>
          <Vehical />
        </div>
        <div className="searches">
          <div className="product-search">
            <select className="form-control">
              <option>Select Category</option>
              <option>AUTOMBILE</option>
              <option>HOME & BUSINESS</option>
            </select>
          </div>
          <div className="product-search">
            <select className="form-control">
              <option>Select Vehical Type</option>
              <option>Bus</option>
              <option>Truck</option>
              <option>Car</option>
              <option>Bike</option>
              <option>E-Rickshaw</option>
              <option>Tractor</option>
              <option>Hups</option>
              <option>Genset</option>
              <option>Inverter</option>
            </select>
          </div>
          <input className="btn btn-primary" type="submit" value="Search" />
        </div>
      </div>
    </div>
  );
}

export default products;
